/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { useAppServices } from "hook/services";
import { useEffect, useState } from "react";
import { useAgencyInfo } from "context/agency";
import { useParams } from "react-router-dom";

export default function dataTableData() {
  const AppService = useAppServices();
  const { product_id } = useParams()
  const [agency] = useAgencyInfo()
  const [List, setList] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loader, setloader] = useState(true);

  const getData = async () => {
    const { response } = await AppService.saas.getProductLocations({
      query: `product_id=${product_id}`,
      toaster: false,
    });
    if (response) {
      setList(response.data);
    } else {
      setList([])
    }
    setloader(false)
  };
  const onLoad = () => {
    getData()
  };
  const handleCreateAccount = async (data) => {
    const { response } = await AppService.saas.create_account_manually({
      payload: data,
    });
    if (response) onLoad();
  };

  useEffect(onLoad, []);
  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: "Name", accessor: "name" },
        { Header: "Email", accessor: "email" },
        { Header: "price_id", accessor: "price_id" },
        { Header: "subscription_id", accessor: "subscription_id" },
        { Header: "Action", accessor: "action" },
      ],

      rows: List.map((data) => ({
        name: data.name,
        email: data.email,
        price_id: data.price_id,
        subscription_id: data.subscription_id,
        // business_name: data.business_name,
        action: (
          <SoftBox>
            {
              data?.account_created == true ?
                <SoftButton
                  variant="contained"
                  color="dark"
                  size="small"
                  sx={{ marginLeft: 2 }}
                >
                  Created
                </SoftButton>
                :
                <SoftButton
                  variant="contained"
                  color="info"
                  size="small"
                  sx={{ marginLeft: 2 }}
                  onClick={() => handleCreateAccount(data)}
                >
                  Create Account
                </SoftButton>
            }

          </SoftBox>
        ),
      })),
    },
  };
}
